export default __webpack_public_path__ + "static/media/BHU.5549bd68.svg";